import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalViewBaremeDetailComponent } from 'src/app/shared/components/modal-view-bareme-detail/modal-view-bareme-detail.component';
import { ModalViewBeneficiaireDetailComponent } from 'src/app/shared/components/modal-view-beneficiaire-detail/modal-view-beneficiaire-detail.component';
import { ModalViewCollegeDetailComponent } from 'src/app/shared/components/modal-view-college-detail/modal-view-college-detail.component';
import { ModalViewCommercialDetailComponent } from 'src/app/shared/components/modal-view-commercial-detail/modal-view-commercial-detail.component';
import { ModalViewCoutierDetailComponent } from 'src/app/shared/components/modal-view-coutier-detail/modal-view-coutier-detail.component';
import { ModalViewGarantDetailsComponent } from 'src/app/shared/components/modal-view-garant-details/modal-view-garant-details.component';
import { ModalViewPoliceDetailsComponent } from 'src/app/shared/components/modal-view-police-details/modal-view-police-details.component';
import { ModalViewProduitBaremeComponent } from 'src/app/shared/components/modal-view-produit-bareme/modal-view-produit-bareme.component';
import { ModalViewProduitDetailComponent } from 'src/app/shared/components/modal-view-produit-detail/modal-view-produit-detail.component';
import { ModalViewreseauDeSoinDetailComponent } from 'src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component';
import { ModalViewSouscripteurDetailComponent } from 'src/app/shared/components/modal-view-souscripteur-detail/modal-view-souscripteur-detail.component';

@Injectable({
  providedIn: 'root'
})
export class ModalDetailService {
  modalRef: BsModalRef;

  constructor(public bsModalRef: BsModalRef,
    private modalService: BsModalService,

  ) { }
    
  onPenDetailModal(item,type,size) {
    let data:any = ''
   
    let modal: any;
    if(type =='beneficiaire'){
      modal = ModalViewBeneficiaireDetailComponent;
      data = item
    }
    if(type =='produit'){
      modal = ModalViewProduitDetailComponent;
      data = item
    }
    if(type =='produitBareme'){
      modal = ModalViewProduitBaremeComponent;
      data = item
    }
    if(type =='bareme'){
      modal = ModalViewBaremeDetailComponent;
      data = item
    }
    if(type =='garant'){
      modal = ModalViewGarantDetailsComponent;
      data = item
    }
    if(type =='college'){
      modal = ModalViewCollegeDetailComponent;
      data = item
    }

    if(type =='police'){
      modal = ModalViewPoliceDetailsComponent;
      data = item
    }
    if(type =='courtier'){
      modal = ModalViewCoutierDetailComponent;
      data = item
    }
    if(type =='commercial'){
      modal = ModalViewCommercialDetailComponent;
      data = item
    }
    if(type =='commercial'){
      modal = ModalViewCommercialDetailComponent;
      data = item
    }
    if(type =='souscripteur'){
      modal = ModalViewSouscripteurDetailComponent;
      data = item
    }

    this.modalRef = this.modalService.show(modal, {
      id: 545805401005,
      class: `modal-width-${size}`,
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    if (data) this.modalRef.content.currentData = data;
    // this.modalRef.onHide.subscribe((res) => {});
  }
  

}
